// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1C-fJ","productName":"Table_productName__1esvw"};